var _g, _circle, _path, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1138_13534)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 26,
    height: 26,
    rx: 7.72414,
    fill: "#E8DEF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 26,
    height: 26,
    rx: 7.72414,
    stroke: "#510C76"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5003,
    cy: 20.052,
    r: 3.58621,
    fill: "white",
    stroke: "#510C76"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7822 18.8301L21.2184 21.2746",
    stroke: "#510C76",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5001,
    cy: 26.3282,
    r: 0.5,
    fill: "#E8DEF1",
    stroke: "#510C76",
    strokeWidth: 0.793103
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1138_13534",
    x: 0,
    y: 0,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1138_13534"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.215686 0 0 0 0 0.109804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1138_13534"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1138_13534",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApOffline);
export default __webpack_public_path__ + "static/media/AP-offline.7c5d3cea7ab0ae143f49262a0def1fa1.svg";
export { ForwardRef as ReactComponent };